import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import InputField from 'components/form/input-field';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import './date-field.scss';

class CustomInput extends Component {
    render() {
        const { label, required, onClick, value, hidePre } = this.props;

        return (
            <div onClick={onClick}>
                <InputField
                    value={value}
                    label={label}
                    required={required}
                    addonPre={!hidePre &&
                        <span style={{width: '100%'}} className="text-center">
                            <FontAwesomeIcon icon={faCalendarAlt} />
                        </span>
                    }
                />
            </div>
        );
    }
}

class DateField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value ? moment(props.value) : null,
        };

        if (props.restrictToMonth) {
            const {minDate, maxDate} = this.getMonthDateRange(this.state.value);
            this.state.minDate = minDate;
            this.state.maxDate = maxDate;
        }

        this.handleChange = this.handleChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        // If value passed to props changes, we must find the option again
        if (this.props.value !== nextProps.value) {
            this.setState({ value: nextProps.value ? moment(nextProps.value) : null });
        }
    }

    handleChange(date) {
        this.setState({value: date});

        if (this.props.onChange) {
            this.props.onChange({
                target: {
                    name: this.props.name,
                    value: date ? date.format() : '',
                    object: date,
                },
            });
        }
    }

    getMonthDateRange(value) {
        if (value) {
            const monthDate = moment(value);
            const minDate = moment(monthDate).startOf('month');
            const maxDate = moment(monthDate).endOf('month');

            return {minDate, maxDate};
        }

        return {minDate: null, maxDate: null}
    }

    render() {
        const { value, minDate, maxDate } = this.state;
        const { label, className, required, disabled, placeholder, hidePre } = this.props;

        return (
            <DatePicker
                onChange={this.handleChange}
                selected={value}
                todayButton="Today"
                placeholderText={placeholder}
                readOnly={disabled}
                required={required}
                className={className}
                customInput={<CustomInput hidePre={hidePre} label={label} />}
                minDate={minDate}
                maxDate={maxDate}
            />
        );
    }
}

DateField.propTypes = {
    name: PropTypes.string,
    id: PropTypes.string,
    value: PropTypes.any,
    className: PropTypes.string,
    //addonPre: PropTypes.node,
    //addonPost: PropTypes.node,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    restrictToMonth: PropTypes.bool,
};

export default DateField;



// WEBPACK FOOTER //
// ./src/components/form/date-field.js